import { useState } from "react";
import { MutateMenuDrawer } from "./MutateMenuDrawer";
import { Menu } from "../models/Menus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { ButtonIcon } from "../../../components/NewButtons";

type Props = {
  menu?: Menu;
};

export const UpdateMenuSelector = ({ menu }: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <ButtonIcon onClick={() => setModalOpen(true)} type="button">
        <FontAwesomeIcon icon={solid("pen")} />
      </ButtonIcon>
      <MutateMenuDrawer
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        menu={menu}
      />
    </div>
  );
};
